<template>
  <div>
    <form-require-noti />
    <v-row>
      <v-col lg="4">
          <label>Patient's Township <require-sign /></label>
                <v-select
                :items="townships"
                v-model="homeVisitEachData.patient_township_id"
                item-text="name"
                item-value="id"
                dense
                outlined
                ></v-select>
        </v-col>
      <v-col lg="4">
        <label>Code</label>
        <small class="text-muted">&nbsp; (eg. 99 or 2)</small>
        <v-text-field
          v-model="homeVisitEachData.mdrtb_code"
          hide-details
          type="number"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col lg="4">
        <label>Year</label>
        <small class="text-muted">&nbsp; (eg. 25)</small>
        <v-text-field
          v-model="homeVisitEachData.mdrtb_year"
          hide-details
          type="number"
          outlined
          dense
        ></v-text-field>
      </v-col>
      
    </v-row>
    <v-row>
      <v-col lg="4">
        <label>Mono-Poly<require-sign /></label>
        <v-select
          v-model="homeVisitEachData.monopoly"
          :items="[
            { id: 1, text: 'No' },
            { id: 2, text: 'Yes' },
            { id: 3, text: 'SG' },
            { id: 4, text: 'MGY' },
          ]"
          :error="$v.homeVisitEachData.monopoly.$error"
          item-text="text"
          item-value="id"
          dense
          outlined
        ></v-select>
      </v-col>
      <v-col lg="4">
        <label>Type</label>
        <v-select
          :items="[
            { id: 1, text: 'In person' },
            { id: 2, text: 'By phone' },
          ]"
          v-model="homeVisitEachData.type"
          :error="$v.homeVisitEachData.type.$error"
          item-text="text"
          item-value="id"
          dense
          outlined
        ></v-select>
      </v-col>
      <!-- <v-col lg="3">
        <label>Outside Township</label>
        <v-select
          :items="[
            { id: '1', text: 'No' },
            { id: '2', text: 'Yes' },
          ]"
          v-model="homeVisitEachData.outside_township"
          :error="$v.homeVisitEachData.outside_township.$error"
          item-text="text"
          item-value="id"
          dense
          outlined
        ></v-select>
      </v-col> -->
      <v-col lg="4">
        <label>Date</label>
        <date-picker
          @clearDate="homeVisitEachData.date = null"
          :has_error="$v.homeVisitEachData.date.$error"
          :date="homeVisitEachData.date"
          v-model="homeVisitEachData.date"
          :min="minDate"
          :max="maxDate"
        />
      </v-col>
    </v-row>
    <v-simple-table dense>
      <template v-slot:default>
        <thead class="header">
          <tr>
            <th>No</th>
            <th>Questions</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="infection in homeVisitEachData.infection_control.slice(0, 7)"
            :key="infection.id"
          >
            <td>{{ infection.id }}</td>
            <td width="70%">{{ showInfectionText(infection.id) }}</td>
            <td>
              <v-radio-group
                class="my-2"
                v-model="infection[Object.keys(infection)[1]]"
                hide-details
                dense
                row
              >
                <v-radio label="Yes" value="2"></v-radio>
                <v-radio label="No" value="1"></v-radio>
              </v-radio-group>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- HOUSE HOLD SECTION -->
    <!-- <v-row>
      <v-col lg="9">
        <p>How many people live with the patient in the same household ?</p>
      </v-col>
      <v-col lg="3">
        <v-text-field
          v-model="homeVisitEachData.lived_patients_no"
          :error="$v.homeVisitEachData.lived_patients_no.$error"
          placeholder="type number only....."
          hide-details
          type="number"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row> -->
    <!-- <v-simple-table dense>
      <template v-slot:default>
        <thead class="header">
          <tr>
            <th>No</th>
            <th>Questions - 8</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(infection,
            index) in homeVisitEachData.infection_control.slice(8, 12)"
            :key="index"
          >
            <td>10.{{ index + 1 }}</td>
            <td width="70%">{{ showInfectionText(infection.id) }}</td>
            <td>
              <v-text-field
                class="my-2"
                v-model="infection[Object.keys(infection)[1]]"
                placeholder="type number only....."
                hide-details
                type="number"
                outlined
                dense
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table> -->

    <!-- AVOID SECTION -->
    <v-divider />
    <p class="mt-4">
      How does the patient reduce transmission and exposure to others while
      he/she is still contagious?
    </p>
    <v-simple-table dense>
      <template v-slot:default>
        <thead class="header">
          <tr>
            <th>No</th>
            <th>Questions - 8</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(infection,
            index) in homeVisitEachData.infection_control.slice(7, 12)"
            :key="index"
          >
            <td>8.{{ index + 1 }}</td>
            <td width="70%">{{ showInfectionText(infection.id) }}</td>
            <td>
              <v-radio-group
                class="my-2"
                hide-details
                v-model="infection[Object.keys(infection)[1]]"
                dense
                row
              >
                <v-radio label="Yes" value="2"></v-radio>
                <v-radio label="No" value="1"></v-radio>
              </v-radio-group>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table dense>
      <template v-slot:default>
        <thead class="header">
          <tr>
            <th>No</th>
            <th>Questions</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="infection in homeVisitEachData.infection_control.slice(12, 15)"
            :key="infection.id"
          >
            <td>{{ infection.id-4 }}</td>
            <td width="70%">{{ showInfectionText(infection.id) }}</td>
            <td>
              <v-radio-group
                class="my-2"
                v-model="infection[Object.keys(infection)[1]]"
                hide-details
                dense
                row
              >
                <v-radio label="Yes" value="2"></v-radio>
                <v-radio label="No" value="1"></v-radio>
              </v-radio-group>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
   
    <v-col lg="10">
      <label>Other Finding</label>
      <v-text-field v-model="homeVisitEachData.infection_remark"></v-text-field>
    </v-col>
    <div class="d-flex justify-end">
      <v-btn outlined color="teal accent-4" dark @click="setInfectionValue">
        Next
        <v-icon right>mdi-arrow-right-thick</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "../../mixins/ValidationMixin";
import { limitDateMixin } from "../../mixins/limitDateMixin";
import { mapState,mapActions } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
import DatePicker from "@/components/common/DatePicker.vue";


export default {
  components: {
    FormRequireNoti,
    DatePicker,
  },
  mixins: [ValidationMixin, limitDateMixin],
  props: {
    month_year: {
      type: Object,
    },
    homeVisitEachData: {
      type: Object,
      default: () => {
        return {
          type: null,
          patient_id:null,
          outside_tsp:null,
          outsidetownship:null,
          date: null,
          patient_township_id:null,
          infection_remark: "",
          sideeffect_remark: "",
          id: null,
          lived_patients_no: 0,
          mdrtb_code: null,
          mdrtb_year: null,
          monopoly:1,
          //! this array will add as a database new column //
          infection_control: [
            { id: 1, value_1: "1" },
            { id: 2, value_2: "1" },
            { id: 3, value_3: "1" },
            { id: 4, value_4: "1" },
            { id: 5, value_5: "1" },
            { id: 6, value_6: "1" },
            { id: 7, value_7: "1" },

             //* QUESTION 7
            { id: 8, value_8: "1" },
            { id: 9, value_9: "1" },
            { id: 10, value_10: "1" },
            { id: 11, value_11: "1" },

            { id: 12, value_12: "1" },
            { id: 13, value_13: "1" },
            { id: 14, value_14: "1" },
            { id: 15, value_15: "1" },

          ],
        };
      },
    },
  },
  data: () => ({
    infectionText: [
      { id: 1, text: "Is the patient taking the drugs regularly?" },
      { id: 2, text: "Is the patient returning to the TB department as scheduled?" },
      { id: 3, text: "Is the sputum being regularly examined as instructed?" },
      { id: 4, text: "Does the patient practice good cough hygiene?" },
      {
        id: 5,
        text: "Wearing of face mask?",
      },
      { id: 6, text: "Does the patient spitt the sputum into the antiseptic solution filled spittoon?" },
      { id: 7, text: "Does the patient dispose the sputum safety?" },

      //8.1,8.2,8.3,8.4,8.5
        { id: 8, text: "Visiting crowded places" },
        {
          id: 9,
          text:
            "Stay close with children, HIV patients, and elderly people",
        },
        { id: 10, text: "Allowing many guests coming to the house?" },
        { id: 11, text: "Travelling during treatment" },
        {
        id: 12,
        text:
          "Cleaning of patient’s room with wet mob and soap powder or disinfectant ",
      },
      //end 8
     
      { id: 13, text: "Opening of windows for good ventilation?" }, //9
      { id: 14, text: "If feasible, isolation of patient at least during the sleeping hours" }, //10
      { id: 15, text: "Conduct contact investigation" },//11
      
      { id: 16, text: "Remark" },

      // { id: 16, text: "children under 5 year" },
      // { id: 17, text: "pregnant woman" },
      // { id: 18, text: "HIV positive patient" },
      // { id: 19, text: "Diabetic patient" },
    ],
  }),
  validations: {
    homeVisitEachData: {
      mdrtb_code: { required },
      mdrtb_year: { required },
      monopoly:{required},
      type: { required },
      date: { required },
    },
  },
  methods: {
    ...mapActions("InfoData", ["getAllTownships"]),
    showInfectionText(id) {
      let infectionObj = this.infectionText.find((e) => e.id == id);
      return infectionObj.text;
    },
    setInfectionValue() {
      //toast validation mixin function
      this.checkToastValidationMsg(this.$v.homeVisitEachData);
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          patient_id:this.patient_id,
          outside_tsp:this.outside_tsp,
          township_id: this.admin.township_id,
          month: this.month_year.month,
          year: this.month_year.year,
          mdrtb_code: this.homeVisitEachData.mdrtb_code,
          mdrtb_year: parseInt(this.homeVisitEachData.mdrtb_year),
          monopoly:this.homeVisitEachData.monopoly==null ? 1 : Number(this.homeVisitEachData.monopoly),
          type: this.homeVisitEachData.type,
          date: this.homeVisitEachData.date,
          infection_remark: this.homeVisitEachData.infection_remark,
          //outside_township: this.homeVisitEachData.outside_township,
          lived_patients_no: this.homeVisitEachData.lived_patients_no,
          infection_control: this.homeVisitEachData.infection_control,
          patient_township_id:this.homeVisitEachData.patient_township_id,
        };

        
        if (this.homeVisitEachData.id) data.id = this.homeVisitEachData.id;

       // const threeDigitPattern = /^[0-9]{3}$/;
        const twoDigitPattern = /^.*[0-9]{2}$/;

        if (
          twoDigitPattern.test(this.homeVisitEachData.mdrtb_year)
        ) {
           this.$store
                .dispatch("HomeVisit/checkCode", data)
                .then((response) => {
               
                  if(response!=false)
                  {
                    this.$toast.success("Success");

                    data.patient_id=response.data.data.id;
                    data.treatment_startdate=response.data.data.treatment_startdate;
                    data.infectionDate=this.homeVisitEachData.date;
                    data.outside_tsp=response.data.data.outside_tsp;
                    // data.home_visit_id=response.data.data.home_visit_id;
                   
                    this.$store.dispatch("HomeVisit/setInfectionAlldata", data);
                   
                   console.log(data);
                    
                    this.$emit("nextSideEffect",data);

                  }else{
                    this.$toast.error("Invalid code or year");
                    
                  }
            });
         
        } else {
          // console.log(threeDigitPattern.test(this.homeVisitEachData.mdrtb_code));
          // if (!threeDigitPattern.test(this.homeVisitEachData.mdrtb_code))
          //   this.$toast.error(
          //     "code must has at least three digit."
          //   );
          if (!twoDigitPattern.test(this.homeVisitEachData.mdrtb_year))
            this.$toast.error("year must has at least two digit.");
          this.clearToastErrors();
        }
      } else {
        //if validation has errors  display with toast
        //then clear the errors
        this.toastErrors.forEach((element) => {
          this.$toast.error(element);
        });
        this.clearToastErrors();
      }
    },
  },
  computed: {
    ...mapState("InitialData", ["months", "years"]),
    ...mapState("Admin", ["admin"]),
    ...mapState("InfoData", [ "townships"]),
  },
  created() {
    this.getAllTownships();
    this.homeVisitEachData.patient_township_id=!this.homeVisitEachData.patient_township_id? Number( this.admin.township_id):Number(this.homeVisitEachData.patient_township_id);
    this.homeVisitEachData.monopoly=!this.homeVisitEachData.monopoly?1:Number(this.homeVisitEachData.monopoly)
  },
  beforeMount() {
    this.homeVisitEachData.date = !this.homeVisitEachData.date
      ? this.minDate
      : this.homeVisitEachData.date;
  },
};
</script>

<style scoped>
p {
  color: #ff6d00;
  letter-spacing: 1px;
}
.text-muted{
  color: #837e7e;
}
.header th {
  color: #fff !important;
  font-size: 15px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 15px !important;
}
.v-input--selection-controls {
  margin-top: 10px !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
</style>
